import { useMemo } from 'react';
import { toast } from 'sonner';
import { useOrganization } from '@/hooks/useOrganization';
import { derivePlanState, planNotReadyMessage, type PlanState } from './planState';

export function usePlanState(): PlanState {
  const { orgInstance, loading, error, refresh } = useOrganization();
  return useMemo(() => ({ ...derivePlanState({ orgInstance, loading, error }), retry: refresh }), [orgInstance, loading, error, refresh]);
}

/** The plan when it is known; otherwise tells the person (with Retry after a failed read) and returns null. */
export function requireReadyPlan(state: PlanState): string | null {
  if (state.status === 'ready' && state.plan) return state.plan;
  const message = planNotReadyMessage(state.status);
  toast.error(message, {
    id: 'plan-not-ready',
    ...(state.status === 'error' ? { action: { label: 'Retry', onClick: () => void state.retry() } } : {}),
  });
  return null;
}
